import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbUp.svg';

export const IconThumbUp = createIconComponent(Icon);
